export * from './text-input'
import textInput from './text-input'
export default textInput
